import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-auth-right-column',
    standalone: true,
    imports: [CommonModule, TranslocoPipe],
    templateUrl: './auth-right-column.component.html',
    styleUrl: './auth-right-column.component.scss',
})
export class AuthRightColumnComponent {}
